import { createBlock } from './block';
import { Block, } from '@chameleoncreator/creator-app';

interface SCORMProps {
  shouldSendScoreWhen: string
  moduleCompleteInterationRequirement: string
  moduleCompleteScoreRequirement: boolean
}

export const createScorm = (props: SCORMProps = {
  shouldSendScoreWhen: "NEVER",
  moduleCompleteInterationRequirement: "allInteractionsSeen",
  moduleCompleteScoreRequirement: false,
}): Block => {
  return createBlock(
    'SCORM',
    [],
    {
      props: {
        shouldSendScoreWhen: props.shouldSendScoreWhen,
        moduleCompleteInterationRequirement: props.moduleCompleteInterationRequirement,
        moduleCompleteScoreRequirement: props.moduleCompleteScoreRequirement
      },
    }
  );
};